export default "__VITE_ASSET__CakFg4os__"